import { createContext } from 'use-context-selector';
import { UserInfoProviderState } from './types';
import { defaultUserInfoProviderState } from './defaultState';

const UserInfoContext = createContext<UserInfoProviderState>(defaultUserInfoProviderState());

export { UserInfoContext };
